<template>
  <f7-popup id="AccountActivation">
    <!-- <page-nav-bar :closePopup="true"></page-nav-bar> -->
    <f7-navbar>
      <f7-nav-left></f7-nav-left>
      <f7-nav-center class="titleApp" sliding></f7-nav-center>
      <f7-nav-right></f7-nav-right>
    </f7-navbar>
    <p class="displayimg">
      <img class="h-sm testimg" id="companyName" src="./../../assets/static/images/CorpMessenger.png"></img>
    </p>
    <f7-card>
      <f7-card-header class="accountActivationCenter">Activate Account</f7-card-header>
      <f7-card-content class="accountActivationCenter">
        <p>Please enter your activation code</p>
        <p>
          <f7-input v-model="activationCode" type="text" class="accountActivationInput"/>
          <!-- <a href="#" class="codeActivationLink" @click="activateAccount()">OK</a> -->
          <f7-button class="blueConfirmationButtonActivationOK button" @click="activateAccount()">OK</f7-button>
        </p>
      </f7-card-content>
    </f7-card>
    <!-- <f7-button class="buttonDetails greenButton" @click="activateAccount()">OK</f7-button> -->
    <f7-button class="blueConfirmationButtonActivation button" @click="sendAnotherCode()">Send another code</f7-button>
    <f7-button class="blueConfirmationButtonActivation button close-popup">Back  <f7-icon size="14px" f7="undo"></f7-icon></f7-button>
  </f7-popup>
</template>
<script>
import moment from 'moment'
import {errorMessageAlert} from '@/helpers/alert'
// import pageNavBar from '@/components/common/pageNavBar.vue'
import _ from 'underscore'
import {loadPage} from '@/helpers/routing'

export default {
  // components: {
  //   'page-nav-bar': pageNavBar
  // },
  props: ['credentials'],
  data: function () {
    return {
      activationCode: ''
    }
  },
  methods: {
    activateAccount () {
      this.$f7.showPreloader('Activating account')
      const that = this
      if (this.activationCode !== '') {
        this.$engine.auth.activate(that.activationCode)
          .then(response => {
            that.$f7.hidePreloader()
            that.status = response.status
            if (response.status === 200) {
              // that.$f7.alert('Please login with your account', 'Account activated')
              this.authUser()
            }
          }).catch(error => {
            errorMessageAlert(error, that)
          })
      } else {
        // that.$f7.prompt('Please enter a valid activation code', 'Incorrect', function (code) {
        //   that.activateAccount(code)
        // })
        that.$f7.hidePreloader()
        that.$f7.alert('Please enter a valid activation code', 'Incorrect')
      }
    },
    authUser () {
      let that = this
      this.$f7.showPreloader('Signing in')
      const creds = _.clone(this.credentials)
      this.$engine.auth.login(creds)
        .then(resp => {
          // that.$f7.hidePreloader()
          // this.$bus.emit('refresh-cache-menu')
          // let serviceInbox = '/inbox/0' // Go to the last service of last account
          // loadPage(that, {url: serviceInbox})
          // that.$f7.popup('#service-switcher-true')
          // TODO delete this part after demo
          that.$engine.services
            .enroll(1, moment('2020-06-10', 'YYYY-MM-DD'))
            .then(response => {
              if (response.status === 200) {
                that.$f7.hidePreloader()
                that.$f7.closeModal()
                this.$bus.emit('refresh-cache-menu')
                loadPage(that, {url: '/dashboard/'})
              }
            }).catch(error => {
              errorMessageAlert(error, that)
            })
          // TODO delete this part after demo
        })
        .catch(err => {
          that.$f7.hidePreloader()
          errorMessageAlert(err, this)
        })
    },
    sendAnotherCode () {
      let that = this
      this.$f7.showPreloader('Sending')
      this.$engine.auth.getNewActivationCode()
        .then(resp => {
          that.$f7.hidePreloader()
          that.$f7.alert('New activation code sent!', 'Ok')
        })
        .catch(err => {
          that.$f7.hidePreloader()
          errorMessageAlert(err, this)
        })
    }
  }
}
</script>
